import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './css/TopNav.css';

function TopNav() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="topnav">
      <div className="logo">
        <a href="/">
        <img src="/vyral.png" alt="VyralMining" />
        <span>VyralMining</span>
        </a>
      </div>

      <button
        className={`menu-toggle ${menuOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>

      <nav className={menuOpen ? 'open' : ''}>
        <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
        <Link to="/start-mining" onClick={() => setMenuOpen(false)}>Dashboard</Link>
        <Link to="/overview" onClick={() => setMenuOpen(false)}>Overview</Link>
      </nav>
    </header>
  );
}

export default TopNav;